import { useNavbarCollapse } from '@shared/layouts/navbar/store/navbar.actions'
import { useIsNavbarCollapsed } from '@shared/layouts/navbar/store/navbar.store'
import cn from 'classnames'

import { Button } from '@components/button/button'

import styles from './toggle-btn.module.css'

type ToggleBtnProps = {
  className?: string
}

export const ToggleBtn = ({ className }: ToggleBtnProps) => {
  const isCollapsed = useIsNavbarCollapsed()
  const { navbarOpen, navbarClose } = useNavbarCollapse()
  const handleClick = () => {
    isCollapsed ? navbarOpen() : navbarClose()
  }
  return (
    <Button
      className={cn(
        styles.container,
        {
          [styles.opened]: isCollapsed === false
        },
        className
      )}
      onClick={handleClick}
      appearance="transparent"
      sizeType="md"
    >
      <span className={styles.top} />
      <span className={styles.middle} />
      <span className={styles.bottom} />
    </Button>
  )
}
